import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a57a6a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "test-questions" }
const _hoisted_2 = { class: "test-text" }
const _hoisted_3 = { class: "test-text__list" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]

import { toRefs } from "vue"
import { Page } from "@/store/exam";

interface Props {
  question: Page
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Layout3',
  props: {
    question: null
  },
  setup(__props: any) {

const props = __props as {
  question: Page
};



const { question } = toRefs(props);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ol", _hoisted_3, [
        _createElementVNode("li", {
          innerHTML: _unref(question).questions[0].choices[0].text
        }, null, 8, _hoisted_4),
        _createElementVNode("li", {
          innerHTML: _unref(question).questions[0].choices[1].text
        }, null, 8, _hoisted_5),
        _createElementVNode("li", {
          innerHTML: _unref(question).questions[0].choices[2].text
        }, null, 8, _hoisted_6)
      ])
    ]),
    (_unref(question).example)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "test-hint",
          innerHTML: _unref(question).questions[0].explanation
        }, null, 8, _hoisted_7))
      : _createCommentVNode("", true)
  ]))
}
}

})